import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router';
import * as R from 'Router/routes';
import TickIcon from 'assets/icons/tick.svg?react';
import CheckIcon from 'assets/icons/check.svg?react';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import { TwButton } from 'components/TwButton/TwButton';
import useClientBankAccountQuery from 'hooks/webapi/client/useClientBankAccountNumber';
import { usePSD2ProxyStatusQuery } from 'hooks/webapi';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function UnorderedList({ lines }: { lines: string[] }) {
  if (lines.length === 0) return null;
  return (
    <div className="bg-background-accent w-full px-7 py-5">
      <ul className="flex flex-col gap-4" data-test="psd2-verified-list">
        {lines.map((item, index) => (
          <li
            key={item}
            className="flex gap-4 items-center"
            data-test={`psd2-verified-item-${index}`}
          >
            <span>
              <CheckIcon
                height={11}
                width={14}
                data-test={`psd2-verified-item-${index}-check-icon`}
              />
            </span>
            <span data-test={`psd2-verified-item-${index}-text`}>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

const PSD2Verified = function PSD2VerifiedMemo() {
  const navigate = useNavigate();
  const { isLoading } = useClientBankAccountQuery();
  const { data: statusData, isSuccess } = usePSD2ProxyStatusQuery();
  const { t } = useTranslation();
  const [lines, setLines] = useState<string[]>([t('psd2_verified:item_1')]);

  useEffect(() => {
    if (isSuccess && statusData.typeOfService === 'PDF_PARSER') {
      setLines([]);
    }
  }, [isSuccess]);

  return (
    <>
      <Helmet>
        <title>{t('psd2_verified:html_title')}</title>
      </Helmet>

      <CardWithIcon
        icon={<TickIcon data-test="psd2-verified-tick-icon" />}
        heading={t('psd2_verified:page_title')}
        dataTest="psd2-verified-card"
      >
        <UnorderedList lines={lines} />
        <div className="mx-auto lg:mx-0 w-full flex justify-center lg:justify-start">
          <TwButton
            onClick={() => {
              navigate(R.WAITING);
            }}
            data-test="psd2-verified"
            disabled={isLoading}
          >
            {t('psd2_verified:complete')}
          </TwButton>
        </div>
      </CardWithIcon>
    </>
  );
};

export default PSD2Verified;
